import { EMPLOYEE_DOCUMENT_HR_TYPES_VALUES } from 'domain/shared/core/constants';

export const READ_EMPLOYEE_DOCUMENTS = 'PEOPLE_MANAGEMENT_EMPLOYEE_DOCUMENT_SEARCH';
export const UPLOAD_EMPLOYEE_DOCUMENTS = 'PEOPLE_MANAGEMENT_EMPLOYEE_DOCUMENT_UPLOAD';
export const UPDATE_EMPLOYEE_DOCUMENTS = 'PEOPLE_MANAGEMENT_EMPLOYEE_DOCUMENT_UPDATE';
export const DOWNLOAD_EMPLOYEE_DOCUMENTS = 'PEOPLE_MANAGEMENT_EMPLOYEE_DOCUMENT_UPDATE';

export const POLISH_OFFICE_PREVIEW_LOCKED_FIELD_IDS = [
  'employeeSalary',
  'employeeSalaryInWords',
  'employeeSalaryInWordsPl',
  'employeeSalaryPerHour',
  'employeeSalaryPerHourInWords',
  'employeeSalaryPerHourInWordsPl',
  'employeeSalaryPerHourInWordsEn',
  'previousEmployeeSalary',
  'previousEmployeeSalaryPerHour',
  'previousEmployeeSalaryPerHourInWords',
  'previousEmployeeSalaryPerHourInWordsPl',
  'currency',
  'currencyPl',
];

// Employee documents sections
export const EMPLOYEE_DOCUMENT_SECTIONS = {
  OTHER: 'OTHER',
  HR: 'HR',
  IDENTITY_DOCUMENT: 'IDENTITY_DOCUMENT',
  COMPLIANCE: 'COMPLIANCE',
};

export const EMPLOYEE_DOCUMENT_SECTIONS_VALUES = {
  [EMPLOYEE_DOCUMENT_SECTIONS.OTHER]: 'Other',
  [EMPLOYEE_DOCUMENT_SECTIONS.HR]: 'HR',
  [EMPLOYEE_DOCUMENT_SECTIONS.IDENTITY_DOCUMENT]: 'Identity document',
  [EMPLOYEE_DOCUMENT_SECTIONS.COMPLIANCE]: 'Compliance',
};
//

// Employee documents types
export const EMPLOYEE_DOCUMENT_OTHER_TYPES = {
  OTHER: 'OTHER',
};
export const EMPLOYEE_DOCUMENT_OTHER_TYPES_VALUES = {
  OTHER: 'Other',
};

// Same with OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES
export const EMPLOYEE_DOCUMENT_HR_TYPES = {
  EMPLOYMENT: 'EMPLOYMENT',
  DISMISSAL: 'DISMISSAL',
  LEAVE: 'LEAVE',
  CONTRACT_EXTENSION: 'CONTRACT_EXTENSION',
  EMPLOYEE_CONFIDENTIALITY_COMPLIANCE: 'EMPLOYEE_CONFIDENTIALITY_COMPLIANCE',
  OTHER: 'OTHER',
};

export const EMPLOYEE_DOCUMENT_IDENTITY_DOCUMENT_TYPES_VALUES = {
  PASSPORT: 'Passport',
  RESIDENCE_PERMIT: 'Residence permit',
  PESEL: 'Pesel',
  IDENTITY_CARD: 'Identity card',
};

export const EMPLOYEE_DOCUMENT_COMPLIANCE_TYPES_VALUES = {
  DATA_PROCESSING: 'Data processing',
  POLICY: 'Policy',
  TRAINING: 'Training',
};

export const TYPES_BY_SECTIONS_EMPLOYEE_DOC = {
  [EMPLOYEE_DOCUMENT_SECTIONS.OTHER]: EMPLOYEE_DOCUMENT_OTHER_TYPES_VALUES,
  [EMPLOYEE_DOCUMENT_SECTIONS.HR]: EMPLOYEE_DOCUMENT_HR_TYPES_VALUES,
  [EMPLOYEE_DOCUMENT_SECTIONS.IDENTITY_DOCUMENT]: EMPLOYEE_DOCUMENT_IDENTITY_DOCUMENT_TYPES_VALUES,
  [EMPLOYEE_DOCUMENT_SECTIONS.COMPLIANCE]: EMPLOYEE_DOCUMENT_COMPLIANCE_TYPES_VALUES,
};

export const ALL_EMPLOYEE_DOC_SECTIONS_TYPES_VALUES = {
  ...EMPLOYEE_DOCUMENT_OTHER_TYPES_VALUES,
  ...EMPLOYEE_DOCUMENT_HR_TYPES_VALUES,
  ...EMPLOYEE_DOCUMENT_IDENTITY_DOCUMENT_TYPES_VALUES,
  ...EMPLOYEE_DOCUMENT_COMPLIANCE_TYPES_VALUES,
};
//

// Employee document stages
export const EMPLOYEE_DOCUMENT_STAGES_ALIAS = {
  UPLOADED: 'UPLOADED',
  SIGNED: 'SIGNED',
  ANNULLED: 'ANNULLED',
};

export const EMPLOYEE_DOCUMENT_STAGES_VALUES = {
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.UPLOADED]: 'Uploaded',
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.SIGNED]: 'Signed',
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED]: 'Annuled',
};

export const HR_EMPLOYEE_DOCUMENT_STAGES_VALUES = {
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.SIGNED]: EMPLOYEE_DOCUMENT_STAGES_VALUES.SIGNED,
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.UPLOADED]: EMPLOYEE_DOCUMENT_STAGES_VALUES.UPLOADED,
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED]: EMPLOYEE_DOCUMENT_STAGES_VALUES.ANNULLED,
};

export const COMPLIANCE_EMPLOYEE_DOCUMENT_STAGES_VALUES = {
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.SIGNED]: EMPLOYEE_DOCUMENT_STAGES_VALUES.SIGNED,
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED]: EMPLOYEE_DOCUMENT_STAGES_VALUES.ANNULLED,
};

export const DEFAULT_EMPLOYEE_DOCUMENT_STAGES_VALUES = {
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.UPLOADED]: EMPLOYEE_DOCUMENT_STAGES_VALUES.UPLOADED,
  [EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED]: EMPLOYEE_DOCUMENT_STAGES_VALUES.ANNULLED,
};
//

// Employee documents Category
export const EMPLOYEE_DOCUMENT_CATEGORY = {
  A: 'A',
  B: 'B',
  C: 'C',
  E: 'E',
};
